<template>
  <div class="d-flex flex-column align-items-start justify-content-center">
    <slot />
  </div>
</template>
